import store from '../index'
import router from '../../router/index'
export default {
  state: {
    info: JSON.parse(localStorage.getItem('rolenames'))||[],
    formLogin:false
  },
  mutations: {
    getInfo (state, info) {
      state.info = info
      localStorage.setItem('rolenames', JSON.stringify(store.getters.info))
    },
    setRole (state, options) { // 切换角色，测试权限管理
      state.info = options
      state.formLogin=true;
      localStorage.setItem('rolenames', JSON.stringify(options))
      store.dispatch('newRoutes', options)
      router.addRoutes(store.getters.addRouters)
    }
  },
  actions: {
    getInfo ({commit}, token) {
      commit('getInfo', token)
    },
    setRole ({commit}, options) {
      // 权限测试
      commit('setRole', options)
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/role.js